type Obj = Record<string, unknown>;

export const isObject = (x: unknown): x is Obj => !!x && typeof x === 'object' && !Array.isArray(x);
export const isString = (x: unknown): x is string => typeof x === 'string';
export const isNumber = (x: unknown): x is number => typeof x === 'number';
// biome-ignore lint/complexity/noBannedTypes: Function is needed for correct type narrowing on union types
export const isFunction = (x: unknown): x is Function => typeof x === 'function';
export const isUndefined = (x: unknown): x is undefined => typeof x === 'undefined';
export const isStringValid = (x: unknown): x is string => isString(x) && !!x;
export const isError = (x: unknown): x is Error => x instanceof Error;
